export default {
  label: {
    id: 'outlet_price_tooltip_label',
    defaultMessage: 'More information',
  },
} as const
